import { useState } from 'react'
import { Button } from 'ui-components-web'

import AvailabilityPopover from '../AvailabilityPopover'

import { ArrowDropdown } from 'components/UI/svgIcons'
import useStyles from './styles'

const Actions = () => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)
  const id = open ? 'availability-popover' : undefined

  const handleAvailabilityClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClosePopover = () => {
    setAnchorEl(null)
  }

  /*

  SHOULD BE REMOVED

  
       <Link to={SCHEDULE_VISIT_REQUESTS} className={classes.link}>
        <Button
          color={'primary'}
          variant={'contained'}
          className={classes.visitRequestsButton}
        >
          Visit requests
          <Observer>
            {() => {
              const q = User.provider?.schedulingsQuantity;
              return q ? (
                <NotificationBubble className={classes.bubble} amount={q} />
              ) : null;
            }}
          </Observer>
        </Button>
      </Link>
  */
  return (
    <div>
      <Button
        color={'primary'}
        variant={'outlined'}
        endIcon={<ArrowDropdown />}
        className={classes.availabilityButton}
        onClick={handleAvailabilityClick}
      >
        Availability
      </Button>
      <AvailabilityPopover id={id} open={open} anchorEl={anchorEl} handleClosePopover={handleClosePopover} />
    </div>
  )
}

export default Actions
